// Action Types
export const GET_ORDER_REQUEST = 'order/GET_ORDER_REQUEST';
export const GET_ORDER_SUCCESS = 'order/GET_ORDER_SUCCESS';
export const GET_ORDER_FAILURE = 'order/GET_ORDER_FAILURE';

export const CREATE_ORDER_REQUEST = 'order/CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'order/CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'order/CREATE_ORDER_FAILURE';

export const UPDATE_ORDER_REQUEST = 'order/UPDATE_ORDER_REQUEST';
export const UPDATE_ORDER_SUCCESS = 'order/UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_FAILURE = 'order/UPDATE_ORDER_FAILURE';


export const UPDATE_ORDER_STATUS_REQUEST = 'order/UPDATE_ORDER_STATUS_REQUEST';
export const UPDATE_ORDER_STATUS_SUCCESS = 'order/UPDATE_ORDER_STATUS_SUCCESS';
export const UPDATE_ORDER_STATUS_FAILURE = 'order/UPDATE_ORDER_STATUS_FAILURE';


// Product Snapshot actions
export const CREATE_PRODUCT_SNAPSHOT_REQUEST = 'order/CREATE_PRODUCT_SNAPSHOT_REQUEST';
export const CREATE_PRODUCT_SNAPSHOT_SUCCESS = 'order/CREATE_PRODUCT_SNAPSHOT_SUCCESS';
export const CREATE_PRODUCT_SNAPSHOT_FAILURE = 'order/CREATE_PRODUCT_SNAPSHOT_FAILURE';

export const UPDATE_PRODUCT_SNAPSHOT_REQUEST = 'order/UPDATE_PRODUCT_SNAPSHOT_REQUEST';
export const UPDATE_PRODUCT_SNAPSHOT_SUCCESS = 'order/UPDATE_PRODUCT_SNAPSHOT_SUCCESS';
export const UPDATE_PRODUCT_SNAPSHOT_FAILURE = 'order/UPDATE_PRODUCT_SNAPSHOT_FAILURE';

export const SEARCH_ORDER_REQUEST = 'order/SEARCH_ORDER_REQUEST';
export const SEARCH_ORDER_SUCCESS = 'order/SEARCH_ORDER_SUCCESS';
export const SEARCH_ORDER_FAILURE = 'order/SEARCH_ORDER_FAILURE';

export const DOWNLOAD_ORDER_PDF_REQUEST = 'order/DOWNLOAD_ORDER_PDF_REQUEST';
export const DOWNLOAD_ORDER_PDF_FAILURE = 'order/DOWNLOAD_ORDER_PDF_FAILURE';

export const DELETE_PRODUCT_SNAPSHOT_REQUEST = 'DELETE_PRODUCT_SNAPSHOT_REQUEST';
export const DELETE_PRODUCT_SNAPSHOT_SUCCESS = 'DELETE_PRODUCT_SNAPSHOT_SUCCESS';
export const DELETE_PRODUCT_SNAPSHOT_FAILURE = 'DELETE_PRODUCT_SNAPSHOT_FAILURE';

export const RESET_ORDER_STATE = 'order/RESET_ORDER_STATE';

// Action Creators

export const resetOrderState = () => ({
    type: RESET_ORDER_STATE,
    payload: undefined
})

// Get Order
export const getOrderRequest = (id) => ({
    type: GET_ORDER_REQUEST,
    payload: {id},
});

export const getOrderSuccess = (order) => ({
    type: GET_ORDER_SUCCESS,
    payload: order,
});

export const getOrderFailure = (error) => ({
    type: GET_ORDER_FAILURE,
    payload: error,
});

// Create Order
export const createOrderRequest = () => ({
    type: CREATE_ORDER_REQUEST,
});

export const createOrderSuccess = (order) => ({
    type: CREATE_ORDER_SUCCESS,
    payload: order,
});

export const createOrderFailure = (error) => ({
    type: CREATE_ORDER_FAILURE,
    payload: error,
});

// Update Order (only discount and customer)
export const updateOrderRequest = (id, updateData) => ({
    type: UPDATE_ORDER_REQUEST,
    payload: {id, updateData},
});

export const updateOrderSuccess = (order) => ({
    type: UPDATE_ORDER_SUCCESS,
    payload: order,
});

export const updateOrderFailure = (error) => ({
    type: UPDATE_ORDER_FAILURE,
    payload: error,
});

// Create Product Snapshot
export const createProductSnapshotRequest = (orderId, snapshotData) => ({
    type: CREATE_PRODUCT_SNAPSHOT_REQUEST,
    payload: {orderId, snapshotData},
});

export const createProductSnapshotSuccess = (order) => ({
    type: CREATE_PRODUCT_SNAPSHOT_SUCCESS,
    payload: order,
});

export const createProductSnapshotFailure = (error) => ({
    type: CREATE_PRODUCT_SNAPSHOT_FAILURE,
    payload: error,
});

// Update Product Snapshot
export const updateProductSnapshotRequest = (productSnapshotData) => ({
    type: UPDATE_PRODUCT_SNAPSHOT_REQUEST,
    payload: productSnapshotData,
});

export const updateProductSnapshotSuccess = (order) => ({
    type: UPDATE_PRODUCT_SNAPSHOT_SUCCESS,
    payload: order
});

export const updateProductSnapshotFailure = (error) => ({
    type: UPDATE_PRODUCT_SNAPSHOT_FAILURE,
    payload: error,
});
export const searchOrderRequest = (searchParams, pageable) => ({
    type: SEARCH_ORDER_REQUEST,
    payload: {searchParams, pageable},
});

export const searchOrderSuccess = (result) => ({
    type: SEARCH_ORDER_SUCCESS,
    payload: result,
});

export const searchOrderFailure = (error) => ({
    type: SEARCH_ORDER_FAILURE,
    payload: error,
});

export const updateOrderStatusRequest = (id, orderStatus) => ({
    type: UPDATE_ORDER_STATUS_REQUEST,
    payload: {id, orderStatus},
});

export const updateOrderStatusSuccess = (order) => ({
    type: UPDATE_ORDER_STATUS_SUCCESS,
    payload: order,
});

export const updateOrderStatusFailure = (error) => ({
    type: UPDATE_ORDER_STATUS_FAILURE,
    payload: error,
});

export const downloadOrderPdfRequest = (orderId, type) => ({
    type: DOWNLOAD_ORDER_PDF_REQUEST,
    payload: {
        orderId: orderId,
        type: type
    }
});

export const deleteProductSnapshotRequest = (payload) => ({
    type: DELETE_PRODUCT_SNAPSHOT_REQUEST,
    payload,
});

export const deleteProductSnapshotSuccess = (snapshotId) => ({
    type: DELETE_PRODUCT_SNAPSHOT_SUCCESS,
    payload: {snapshotId: snapshotId},
});

export const deleteProductSnapshotFailure = (error) => ({
    type: DELETE_PRODUCT_SNAPSHOT_FAILURE,
    error,
});